module.exports = "/images/ca-bc.svg?aee5663fdfaea220f7465895330fae17";